<template>
  <Properties :component="component">
    <template #library-properties>
      <h1>Properties</h1>
    </template>
  </Properties>
</template>

<script lang="ts">
import Properties from '~/components/library/Properties.vue';
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'Theme9Properties',

  mixins: [ComponentMixin],

  extends: Properties,

  components: {
    Properties,
  },
});
</script>
